<ui-table-selection
  [checked]="nzChecked"
  [disabled]="nzDisabled"
  [indeterminate]="nzIndeterminate"
  [listOfSelections]="nzSelections"
  [showCheckbox]="nzShowCheckbox"
  [showRowSelection]="nzShowRowSelection"
  (checkedChange)="onCheckedChange($event)"></ui-table-selection>
<ng-content></ng-content>
